import { CssRender } from 'css-render';
const { c } = CssRender();
export { c };
